/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Create_ButtonInputs */

const en_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const fr_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

const de_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const it_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creare`)
};

const ru_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создавать`)
};

const es_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const zh_cn2_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创造`)
};

const ja_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成する`)
};

const hi_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाएं`)
};

const pt_pt2_options_api_keys_create_button = /** @type {(inputs: Options_Api_Keys_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Options_Api_Keys_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_create_button = /** @type {((inputs?: Options_Api_Keys_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_create_button(inputs)
	if (locale === "de") return de_options_api_keys_create_button(inputs)
	if (locale === "it") return it_options_api_keys_create_button(inputs)
	if (locale === "ru") return ru_options_api_keys_create_button(inputs)
	if (locale === "es") return es_options_api_keys_create_button(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_create_button(inputs)
	if (locale === "ja") return ja_options_api_keys_create_button(inputs)
	if (locale === "hi") return hi_options_api_keys_create_button(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_create_button(inputs)
	return en_options_api_keys_create_button(inputs)
});